import type { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

export type SelectValueProps = ComponentProps<typeof SelectPrimitive.Value>;

export const SelectValue = (props: SelectValueProps) => (
  <SelectPrimitive.Value data-slot="select-value" {...props} />
);
